<template>
    <md-report-layout :header-buttons="headerButtons" :loading="loading" :loading-text="loadingText" ref="reportLayout">
        <template v-slot:header-left>
            <dateselectionheader style="position:static;" :label="`${reportYear}`" :disableCalendar="true"
                                 :disableToday="true"
                                 @PrevDate="changeSelection('down')" @NextDate="changeSelection('up')" />
        </template>
        <template v-slot:employee-list>
            <EmployeeList :class="anonMode ? 'anonblur' : ''" :loading="loadingEmployees"
                          :employees="visibleEmployees"
                          @employeeSelected="onEmployeeSelected" />
            <div class="header"
                 style="font-size: 13px; padding-left: 5px; font-weight:bold; margin-bottom: 10px; text-align: left">
                {{ $t('report.main.xOfYEmployeesSelected', [countSelectedEmployees, countEmployees]) }}
            </div>
            <EmployeeButtons :selectAllEmployees="selectAllEmployees" :deselectAllEmployees="deselectAllEmployees"
                             :toggleShowOnlyActiveEmployees="toggleShowOnlyActiveEmployees"
                             :showOnlyActiveEmployees="showOnlyActiveEmployees" />
        </template>
        <template v-slot:report-settings>
            <ReportConfig :options="reportConfigData" @configChanged="onReportConfigChange" />
        </template>
        <template v-slot:report-list>
            <div style="text-align:left; font-weight:bold; font-size: 20px;">
                {{ $t('report.main.reportList') }}
            </div>
            <div  class="reports-list">
                <datatablesimple :state="reportState" />
            </div>
            <div v-if="reports.length == 0">
                {{ $t('report.main.noReportsCreated') }}
            </div>
        </template>
        <template v-slot:button-bar v-if="creatingReport || !canCreateReport">
      <span v-if="creatingReport">
        <i class="fas fa-circle-notch fa-spin"></i>
        {{ $t('report.main.reportCreating') }}
      </span>
            <span v-else-if="selectedEmployees.length === 0">
        {{ $t('pref.main.pleaseSelectEmployee') }}
      </span>
            <span v-else>
        {{ $t('report.main.pleaseSelectQuarter') }}
      </span>
        </template>
    </md-report-layout>
</template>

<script>
import MdReportLayout from '@/components/reportcontext/ReportLayout';
import { reportMixin } from '@/components/reportcontext/report-mixin';
import ReportConfig from '@/shared/components/ReportConfig.vue';
import EmployeeList from '@/shared/components/EmployeeList.vue';
import EmployeeButtons from '@/shared/components/EmployeeButtons.vue';

export default {
    name: 'reportaccountingperiod',
    components: {
        EmployeeButtons,
        EmployeeList,
        ReportConfig,
        MdReportLayout,
    },
    mixins: [reportMixin],
    data() {
        return {
            loadingText: this.$t('report.main.loadX', [this.$t('workBalance.accounting.title')]),

            reportYear: 2020,
            reportMonth: 8,
            recalculatedWholeYear: false,
            showOnlyActiveEmployees: true,
        };
    },
    created() {
        this.reportYear = this.$helpers.getCurrentMonthMomentTZ().year();
        this.reportMonth = this.$helpers.getCurrentMonthMomentTZ().month() + 1;

    },
    mounted() {
        if (this.$store.state.jwt !== undefined && this.$store.state.storeId !== undefined) {
            this.refresh();
        }
    },
    computed: {
        headerButtons() {
            let helperLinks = [];
            let buttons = [
                {
                    classes: 'add-employeetype',
                    type: 'block gray',
                    disabled: false,
                    icon: 'fa-th-list',
                    click: ($event) => {
                    },
                    show: true,
                    tooltip: this.$t('report.main.accountingPeriod'),
                },
                {
                    type: 'block green',
                    disabled: this.creatingReport || !this.canCreateReport,
                    icon: this.creatingReport ? 'fa-redo' : 'fa-file-check',
                    click: ($event) => {
                        this.createReportProxy();
                    },
                    show: true,
                    tooltip: this.$t('global.ui.createX', [this.$t('roster.view.report')]),
                },
            ];
            let state = {
                buttons: buttons,
                helperLinks: helperLinks,
                showListIconAlways: true,
            };

            state.helperLinks = [
                {
                    title: this.$t('report.main.reportAccountingPeriod'),
                    helperText: this.$t('report.main.reportAccountingPeriodHelp'),
                    externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText: this.$t('store.structure.getSupportHelp'),
                    externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
            ];
            return state;
        },

        canCreateReport() {
            return this.selectedEmployees.length > 0 && this.getReportConfigValue(['quarters', 'settingEnabledQuarters'], []).length > 0;
        },
        reportState() {
            if (this.reports === undefined || this.reports.length < 1) {
                return null;
            }

            let data = Object.values(this.reports);

            let columns = {
                name: this.$t('report.main.documentName'),
                format: this.$t('report.main.fileFormat'),
                creationDate: this.$t('global.menubar.sortOptionCreationDate'),
                comment: this.$t('global.general.comment'),
                actions: ' ',
            };

            let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            this.$helpers.buildHeaderMapLabel(state.headerMap, 'name');
            this.$helpers.buildHeaderMapLabel(state.headerMap, 'format');
            this.$helpers.buildHeaderMapLabel(state.headerMap, 'creationDate');
            this.$helpers.buildHeaderMapLabel(state.headerMap, 'comment');
            this.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
            state.headerMap.actions.componentStateBuilders = [
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.open');
                        },
                        type: 'button square rounded no-border',
                        icon: 'fas fa-envelope-open',
                        customEvents: {
                            click: () => {
                                this.openReportUrl(data.url);
                            },
                        },
                    };
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.download');
                        },
                        type: 'button square rounded no-border green',
                        icon: 'fas fa-download',
                        customEvents: {
                            click: () => {
                                this.downloadReport(data);
                            },
                        },
                    };
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.delete');
                        },
                        type: 'button square rounded no-border red',
                        icon: 'fas fa-trash',
                        customEvents: {
                            click: () => {
                                this.openDeleteReportPopup(data);
                            },
                        },
                    };
                },
                // open report openReport
            ];

            let entries = Object.entries(state.headerMap);

            entries[0][1].key = 'name';
            entries[0][1].width = '30%';
            entries[1][1].key = 'format';
            entries[1][1].width = '10%';
            entries[2][1].key = 'creationDate';
            entries[2][1].width = '20%';
            entries[3][1].key = 'comment';
            entries[3][1].width = '25%';
            entries[4][1].key = 'actions';
            entries[4][1].width = '15%';

            state.headerStyles = { fontSize: '10px', position: 'sticky', top: 0, zIndex: 10 };
            state.heightSubRow = 'fit-content';
            state.rowStylesCollapsed = this.strippedRowStyle();
            state.alwaysUnfold = false;

            return state;
        },
    },
    watch: {
        storeId(newVal, oldVal) {
            this.refresh(true);
        },
    },
    // methods that implement data logic.
    methods: {
        getReportName() {
            return this.$t('report.main.reportAccountingPeriod') + ', ' + this.reportYear;
        },
        async refresh(force = false) {
            this.loading = true;
            this.updateReportConfig('reportname', this.getReportName());
            let from = this.$helpers.getMomentFromValuesTZ(this.reportYear, 0, 1);
            let to = from.clone().add(1, 'year');
            try {
                await Promise.all([
                    this.$helpers.GetExportSettingsMap(force),
                    this.loadReports('ACCOUNTINGPERIOD'),
                    this.loadEmployees(true, from, to),
                ]);
            } catch (error) {
                console.error(error);
            } finally {
                this.generateReportConfigOpts();

                this.reportConfig = this.loadReportConfig();
                this.updateReportConfig('reportname', this.getReportName());
                this.loading = false;
            }
        },

        generateReportConfigOpts() {
            let disabled = !this.CheckEnableConfigEdit;
            let specialDisabled = !this.CheckEnableConfigSpecialEdit;


            const nameSection = this.createReportConfigSection(this.$t('report.main.documentName'), true);
            this.addTextConfigOption(nameSection, 'reportname', this.$t('report.main.enterDocumentName'), this.getReportName(), true);

            const contentSection = this.createReportConfigSection(this.$t('report.main.documentContent'), true, disabled);
            this.addSelectConfigOption(contentSection, 'quarters', [
                this.addSelectableValue(this.$tc('report.main.quarter', 2), [
                    this.addSelectableValue('1. ' + this.$tc('report.main.quarter'), 1),
                    this.addSelectableValue('2. ' + this.$tc('report.main.quarter'), 2),
                    this.addSelectableValue('3. ' + this.$tc('report.main.quarter'), 3),
                    this.addSelectableValue('4. ' + this.$tc('report.main.quarter'), 4),
                ], [1, 2, 3, 4], 'settingEnabledQuarters'),
            ], true);

            const positiveDiffSection = this.createReportConfigSection(this.$t('report.main.textWithPositiveCarryOver'), true, specialDisabled);
            this.addTextConfigOption(positiveDiffSection, 'positiveDiffTxt', this.$t('report.main.hintWithPositiveCarryOver'), this.$t('report.main.positiveCarryOverHelp'));

            const negativeDiffSection = this.createReportConfigSection(this.$t('report.main.textWithNegativeCarryOver'), true, specialDisabled);
            this.addTextConfigOption(negativeDiffSection, 'negativeDiffTxt', this.$t('report.main.hintWithNegativeCarryOver'), this.$t('report.main.negativeCarryOverHelp'));

            const documentFormatSection = this.createReportConfigSection(this.$t('report.main.documentForm'), false, disabled);
            this.addSelectConfigOption(documentFormatSection, 'settingEmployeeFormat', [
                this.addSelectableValue(this.$t('report.main.pageBreakAfterEachEmployee'), 'one', true),
                this.addSelectableValue(this.$t('report.main.multipleEmployeesPerPage'), 'dynamic'),
            ]);
            this.addSelectConfigOption(documentFormatSection, 'settingSignatureLine', [
                this.addSelectableValue(this.$t('global.ui.showX', [this.$t('report.main.signatureField')]), true, true),
                this.addSelectableValue(this.$t('global.ui.hideX', [this.$t('report.main.signatureField')]), false),
            ]);
            this.addSelectConfigOption(documentFormatSection, 'settingFontSize', [
                this.addSelectableValue(this.$t('report.main.textSizeNormal'), 'default', true),
                this.addSelectableValue(this.$t('report.main.textSizeLarge'), 'big'),
            ]);

            const headerFormatSection = this.createReportConfigSection(this.$t('report.main.header'), false, specialDisabled);
            this.addSelectConfigOption(headerFormatSection, 'settingDateFormat', [
                this.addSelectableValue('DD.MM.YYYY', 'DD.MM.YYYY', true),
                this.addSelectableValue('YYYY-MM-DD', 'YYYY-MM-DD'),
            ]);
            this.addSelectConfigOption(headerFormatSection, 'headerShowCreationDate', [
                this.addSelectableValue(this.$t('global.ui.showX', [this.$t('global.general.creationDate')]), true, true),
                this.addSelectableValue(this.$t('global.ui.hideX', [this.$t('global.general.creationDate')]), false),
            ]);
            this.addSelectConfigOption(headerFormatSection, 'headerShowQr', [
                this.addSelectableValue(this.$t('global.ui.showX', [this.$t('report.main.qrCode')]), true, true),
                this.addSelectableValue(this.$t('global.ui.hideX', [this.$t('report.main.qrCode')]), false),
            ]);
        },

        changeSelection(method) {
            if (method === 'down') {
                this.reportYear--;
            } else {
                this.reportYear++;
            }

            this.updateReportConfig('reportname', this.getReportName());
            let from = this.$helpers.getMomentFromValuesTZ(this.reportYear, 0, 1);
            let to = from.clone().add(1, 'year');
            this.loadEmployees(true, from, to);
        },

        async createReportProxy() {
            await this.recalculateBalancesFully();
            await this.recalculatePreviousMonthWorkbalances();
            await this.generateReport();
        },
        async recalculateBalancesFully() {
            if (this.recalculatedWholeYear) return true;

            const employeeIds = this.employees.map(({ id }) => id);
            let fromDate = this.$helpers.getMomentFromValuesUTC(this.reportYear, 0, 1);
            let toDate = this.$helpers.getMomentFromValuesUTC(this.reportYear, 11, 1);

            let currentMonth = this.$helpers.getCurrentMonthMomentUTC();
            if (toDate > currentMonth && toDate.year() === currentMonth.year()) {
                toDate = currentMonth;
            }

            const oldLoadingText = this.loadingText;

            this.loading = true;
            this.loadingText = this.$t('pref.main.updateMonthEndClosings');

            let returnState = false;
            try {
                await this.$refs.reportLayout.$refs.employeeworkbalancecreation.recalculateFromTo(fromDate, toDate, employeeIds, true, true);
                returnState = true;
                this.recalculatedWholeYear = true;
            } catch (e) {
                console.error(e);
            } finally {
                this.loading = false;
                this.loadingText = oldLoadingText;
            }
            return returnState;
        },
        async recalculatePreviousMonthWorkbalances() {
            const employeeIds = this.selectedEmployeeIds;

            const yearDate = this.$helpers.getMomentFromValuesUTC(this.reportYear, Math.max(0, this.reportMonth - 1), 1).add(1, 'months');
            console.log(yearDate.format());

            const oldLoadingText = this.loadingText;

            this.loading = true;
            this.loadingText = this.$t('pref.main.updateMonthEndClosings');

            let returnState = false;
            try {
                await this.$refs.reportLayout.$refs.employeeworkbalancecreation.recalculatePastInvalid(yearDate, employeeIds, null, true);
                returnState = true;
            } catch (e) {
                console.error(e);
            } finally {
                this.loading = false;
                this.loadingText = oldLoadingText;
            }
            return returnState;
        },

        async generateReport() {
            this.creatingreport = true;

            const employeeIds = this.selectedEmployeeIds;

            const dateFormats = {
                'DD.MM.YYYY': 'dmY',
                'YYYY-MM-DD': 'Ymd',
            };
            const dateFormat = dateFormats[this.reportConfig.settingDateFormat] || 'dmY';

            /*let hourFormat = '3';
            if (view.settingHourFormat == '3') {
              hourFormat = '3';
            } else if (view.settingHourFormat == '2') {
              hourFormat = '2';
            } else if (view.settingHourFormat == 'Hm') {
              hourFormat = 'Hm';
            }*/

            const name = this.reportConfig.reportname;
            const comment = this.reportConfig.reportcomment;
            const config = {
                'year': this.reportYear,
                'month': this.reportMonth,
                'employeeIds': employeeIds,
                'headerDateFormat': dateFormat,
                'pageFormat': this.reportConfig.settingEmployeeFormat,
                'colorFormat': 'color', // view.settingColorFormat,
                'fontSize': this.reportConfig.settingFontSize,
                'showSignatureLine': this.reportConfig.settingSignatureLine,
                // 'hourFormat': hourFormat,
                'settingFileContentLineOne': true, // view.settingFileContentLineOne
                // 'settingFileContentLineTwo': view.settingFileContentLineTwo,
                // 'settingFileContentLineThree': view.settingFileContentLineThree,
                'positiveDiffTxt': this.reportConfig.positiveDiffTxt,
                'negativeDiffTxt': this.reportConfig.negativeDiffTxt,
                'headerShowQr': this.reportConfig.headerShowQr,
                'headerShowCreationDate': this.reportConfig.headerShowCreationDate,
                'enabledQuarters': this.reportConfig.quarters.settingEnabledQuarters,
                'env': 'production',
                'documentComment': comment,
            };

            await this.createReport('ACCOUNTINGPERIOD', name, comment, config);
        },
    },
};
</script>

<style scoped>
</style>
